import WDSVariables from '@fandom-frontend/design-system/dist/variables.json';
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["Small"] = parseInt(WDSVariables.wdsBreakpointSmall)] = "Small";
    Breakpoints[Breakpoints["Medium"] = parseInt(WDSVariables.wdsBreakpointMedium)] = "Medium";
    Breakpoints[Breakpoints["Large"] = parseInt(WDSVariables.wdsBreakpointLarge)] = "Large";
    Breakpoints[Breakpoints["XLarge"] = parseInt(WDSVariables.wdsBreakpointXlarge)] = "XLarge";
    Breakpoints[Breakpoints["XxLarge"] = parseInt(WDSVariables.wdsBreakpointXxlarge)] = "XxLarge";
})(Breakpoints || (Breakpoints = {}));
var mediaQueryString = function (query) { return "only screen and ".concat(query); };
export var MediaQueries = Object.freeze({
    // up breakpoints
    SmallUp: WDSVariables.wdsBreakpointSmallUp,
    MediumUp: mediaQueryString(WDSVariables.wdsBreakpointMediumUp),
    LargeUp: mediaQueryString(WDSVariables.wdsBreakpointLargeUp),
    XLargeUp: mediaQueryString(WDSVariables.wdsBreakpointXlargeUp),
    XxLargeUp: mediaQueryString(WDSVariables.wdsBreakpointXxlargeUp),
    // down breakpoints
    SmallDown: mediaQueryString(WDSVariables.wdsBreakpointSmallOnly),
    MediumDown: mediaQueryString(WDSVariables.wdsBreakpointMediumOnly),
    LargeDown: mediaQueryString(WDSVariables.wdsBreakpointLargeOnly),
    XLargeDown: mediaQueryString(WDSVariables.wdsBreakpointXlargeOnly),
    XxLargeDown: WDSVariables.wdsBreakpointXxlargeDown,
    // only breakpoints
    SmallOnly: mediaQueryString(WDSVariables.wdsBreakpointSmallOnly),
    MediumOnly: mediaQueryString("".concat(WDSVariables.wdsBreakpointMediumUp, " and ").concat(WDSVariables.wdsBreakpointMediumOnly)),
    LargeOnly: mediaQueryString("".concat(WDSVariables.wdsBreakpointLargeUp, " and ").concat(WDSVariables.wdsBreakpointXlargeDown)),
    XLargeOnly: mediaQueryString("".concat(WDSVariables.wdsBreakpointXlargeUp, " and ").concat(WDSVariables.wdsBreakpointXlargeDown)),
    XxLargeOnly: mediaQueryString("".concat(WDSVariables.wdsBreakpointXxlargeOnly)),
});
